"use strict";

define('rs/helper',['evisions/helper', 'jquery'], function (helper, $) {
  helper.irb = true;
  $(function () {
    helper.supportMaxLength = function () {
      if (helper.maxLengthExists) {
        return helper.maxLengthExists;
      }
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.setAttribute('maxlength', 1);
      helper.maxLengthExists = !(textarea.maxLength == null);
      document.body.removeChild(textarea);
      return helper.maxLengthExists;
    };
    if (!helper.supportMaxLength()) {
      $(document.body).on('keypress', 'textarea', function (ev) {
        var el = $(this),
          currentValue = el.val(),
          maxLength = el.attr('maxLength');
        if (maxLength && currentValue.length >= maxLength) {
          ev.preventDefault();
        }
      });
    }
  });
  helper.parseServerEnum = function (str) {
    var i = 0,
      sections = String(str).toUpperCase().split(/[_\s]+/g),
      s = '',
      len = sections.length;
    for (i = 0; i < len; ++i) {
      s = sections[i];
      switch (s) {
        case 'IRB':
        case 'ID':
        case 'PI':
          break;
        default:
          s = s[0] + s.slice(1).toLowerCase();
          break;
      }
      sections[i] = s;
    }
    return sections.join(' ');
  };
  window._csrf_token = null;
  $(document).ajaxComplete(function (e, req, options) {
    if (req.getResponseHeader('x-csrf-token')) {
      window._csrf_token = req.getResponseHeader('x-csrf-token');
    }
  }).ajaxSend(function (e, xhr, options) {
    if (options && options.type !== 'GET' && window._csrf_token) {
      xhr.setRequestHeader(window._csrf_header_name, window._csrf_token);
    }
  });
  $.ajaxSetup({
    cache: false
  });
  return helper;
});

